export enum APP_ENVIRONMENT_CONSTANTS {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}
